import React, { PureComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  Brush,
  ReferenceLine,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from 'recharts';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton, InputLabel, MenuItem, Select,
  TextField
} from '@mui/material';
import { getNodeDetailsPercentAvailability } from '../../../store/fuse/dashboard';
import {DatePicker} from "@mui/x-date-pickers";
import TimelineIcon from "@mui/icons-material/Timeline";
import BarChartIcon from "@mui/icons-material/BarChart";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ExportCSVChart from "../export/Export";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import {WrapperInput, WrapperInputsGraficas} from "../styles";

const PercentAvailability = ({ filters, name }) => {
  const { nodeId } = useParams();
  const dispatch = useDispatch();
  const [dataRange, setDataRange] = useState('day');
  const [currentRanges, setCurrentRanges] = useState('');
  const chartData = useSelector((state) => state?.fuse?.dashboard?.nodeDetails?.percentAvailability);
  const [dateInit,setDateInit] = useState(moment().subtract(24, 'hour').format('Y-MM-DD HH:mm:00'));
  const [dateEnd,setDateEnd] = useState(moment().format('Y-MM-DD HH:mm:00'));
  const [openModal, setOpenModal] = useState(false);
 

  const handleRangeClick = (range,init,end) => {
    setDataRange('filters');
    const dates = {fechaFin: end || dateEnd, fechaIni: init || dateInit}
    dispatch(getNodeDetailsPercentAvailability(nodeId, range, dates));
  };

  const handleDateInitChange = (newValue) => {
    if (newValue !== dateInit) {
      const dateIn = moment(newValue).format('Y-MM-DD HH:mm:00')
      setDateInit(dateIn);
      handleRangeClick('filters', dateIn, null)
    }
  };

  const handleDateEndChange = (newValue) => {
    if (newValue !== dateEnd) {
      const date = moment(newValue).format('Y-MM-DD HH:mm:00')
      setDateEnd(date);
      handleRangeClick('filters', null, date)
    }
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  
  return (
    <>
    <div style={{ width: '100%', height: '650px' }}>
      <strong className="title-chart">Disponibilidad Porcentaje</strong>
      <div style={{ width: '100%', textAlign: 'center', marginBottom: '20px' }}>
        <h3 style={{ fontWeight: 'bold' }}>{name}</h3>
        <h3>{currentRanges}</h3>
      </div>
       <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%',marginBottom: '1rem',
        marginTop: '1rem',  marginRight:'3rem', marginLeft:'2rem', paddingRight:'5rem'}}>
         { /*<div>
            <Box sx={{ width: '90%' , marginRight:'1.4rem'}}>
              <DatePicker
                onChange={(newValue) => handleDateInitChange(newValue)}
                label="Fecha Inicio"
                value={dateInit}
                renderInput={(params) => <TextField {...params} sx={{ width: '95%' }} />}
              />
            </Box>
        </div>
        <div>
            <Box sx={{ width: '90%', marginLeft:'2rem' }}>
              <DatePicker
                onChange={(newValue) => handleDateEndChange(newValue)}
                label="Fecha Fin"
                value={dateEnd}
                renderInput={(params) => <TextField {...params} sx={{ width: '95%' }} />}
              />
            </Box>
        </div>*/}
        <div>
          <IconButton aria-label="download-chart" size="medium">
            <ExportCSVChart fileName={'Disponibilidad'} data={chartData} />
          </IconButton>
          <IconButton aria-label="fullscreen" size="medium" onClick={handleOpenModal}>
            <FullscreenIcon />
          </IconButton>
        </div>
      </div>
      <div style={{ width: '100%', height: '80%' }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={500}
            height={300}
            data={chartData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="fecha" type="category" />
            <YAxis domain={[0, 110]}>
              <Label angle={-90} value="% Disponible" position="insideLeft" style={{ textAnchor: 'middle' }} />
            </YAxis>
            <Tooltip labelStyle={{ color: '#000000' }} />
            <ReferenceLine y={0} stroke="#000" />
            <Brush dataKey="fecha" height={30} stroke="#8884d8" />
            {/* <Bar dataKey="disponibilidad" fill="#82ca9d" name="% Disponible" /> */}
            <Line 
              dataKey="disponibilidad" 
              name="% Disponible" 
              stroke="#82ca9d" 
              strokeWidth={3}
              dot={true}/>
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
      {/* Modal para el gráfico */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        fullWidth
        fullScreen>
        <DialogTitle>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <strong className="title-chart">Disponibilidad Porcentaje</strong>
            <div>
                <Box sx={{ width: '80%' }}>
                  <DatePicker
                    onChange={(newValue) => handleDateInitChange(newValue)}
                    label="Fecha Inicio"
                    value={dateInit}
                    renderInput={(params) => <TextField {...params} sx={{ width: '95%' }} />}
                  />
                </Box>
            </div>
            <div>
                <Box sx={{ width: '80%' }}>
                  <DatePicker
                    onChange={(newValue) => handleDateEndChange(newValue)}
                    label="Fecha Fin"
                    value={dateEnd}
                    renderInput={(params) => <TextField {...params} sx={{ width: '95%' }} />}
                  />
                </Box>
            </div>
            <div>
              <IconButton aria-label="download-chart" size="medium">
                <ExportCSVChart fileName={'Disponibilidad'} data={chartData} />
              </IconButton>
              <IconButton aria-label="fullscreen" size="medium" onClick={handleCloseModal}>
                <FullscreenExitIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              width={500}
              height={300}
              data={chartData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="fecha" type="category" />
              <YAxis domain={[0, 110]}>
                <Label angle={-90} value="% Disponible" position="insideLeft" style={{ textAnchor: 'middle' }} />
              </YAxis>
              <Tooltip labelStyle={{ color: '#000000' }} />
              <ReferenceLine y={0} stroke="#000" />
              <Brush dataKey="fecha" height={30} stroke="#8884d8" />
              {/* <Bar dataKey="disponibilidad" fill="#82ca9d" name="% Disponible" /> */}
              <Line
                dataKey="disponibilidad"
                name="% Disponible"
                stroke="#82ca9d"
                strokeWidth={3}
                dot={true}/>
            </LineChart>
          </ResponsiveContainer>
        </DialogContent>
      </Dialog>
      </>
  );
};

export default PercentAvailability;
